"use strict";

var _regeneratorRuntime = require("/data/trilogy-group/totogi-developer-portal/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/data/trilogy-group/totogi-developer-portal/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/data/trilogy-group/totogi-developer-portal/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRedoclyRegistryURL = exports.RedoclyClient = void 0;

var fs_1 = require("fs");

var path_1 = require("path");

var os_1 = require("os");

var colorette_1 = require("colorette");

var registry_api_1 = require("./registry-api");

var TOKEN_FILENAME = '.redocly-config.json';

var RedoclyClient = /*#__PURE__*/function () {
  function RedoclyClient() {
    _classCallCheck(this, RedoclyClient);

    this.loadToken();
    this.registryApi = new registry_api_1.RegistryApi(this.accessToken);
  }

  _createClass(RedoclyClient, [{
    key: "hasToken",
    value: function hasToken() {
      return !!this.accessToken;
    }
  }, {
    key: "loadToken",
    value: function loadToken() {
      if (process.env.REDOCLY_AUTHORIZATION) {
        this.accessToken = process.env.REDOCLY_AUTHORIZATION;
        return;
      }

      var credentialsPath = path_1.resolve(os_1.homedir(), TOKEN_FILENAME);

      if (fs_1.existsSync(credentialsPath)) {
        var credentials = JSON.parse(fs_1.readFileSync(credentialsPath, 'utf-8'));
        this.accessToken = credentials && credentials.token;
      }
    }
  }, {
    key: "isAuthorizedWithRedocly",
    value: function isAuthorizedWithRedocly() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = this.hasToken();

                if (!_context.t0) {
                  _context.next = 5;
                  break;
                }

                _context.next = 4;
                return this.getAuthorizationHeader();

              case 4:
                _context.t0 = !!_context.sent;

              case 5:
                return _context.abrupt("return", _context.t0);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "verifyToken",
    value: function verifyToken(accessToken) {
      var verbose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (accessToken) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", false);

              case 2:
                return _context2.abrupt("return", this.registryApi.setAccessToken(accessToken).authStatus(verbose));

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "getAuthorizationHeader",
    value: function getAuthorizationHeader() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.t0 = this.accessToken;

                if (!_context3.t0) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 4;
                return this.verifyToken(this.accessToken);

              case 4:
                _context3.t0 = !_context3.sent;

              case 5:
                if (!_context3.t0) {
                  _context3.next = 8;
                  break;
                }

                process.stderr.write("".concat(colorette_1.yellow('Warning:'), " invalid Redocly API key. Use \"npx @redocly/openapi-cli login\" to provide your API key\n"));
                return _context3.abrupt("return", undefined);

              case 8:
                return _context3.abrupt("return", this.accessToken);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "login",
    value: function login(accessToken) {
      var verbose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var credentialsPath, authorized, credentials;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                credentialsPath = path_1.resolve(os_1.homedir(), TOKEN_FILENAME);
                process.stdout.write(colorette_1.gray('\n  Logging in...\n'));
                _context4.next = 4;
                return this.verifyToken(accessToken, verbose);

              case 4:
                authorized = _context4.sent;

                if (!authorized) {
                  process.stdout.write(colorette_1.red('Authorization failed. Please check if you entered a valid API key.\n'));
                  process.exit(1);
                }

                this.accessToken = accessToken;
                credentials = {
                  token: accessToken
                };
                fs_1.writeFileSync(credentialsPath, JSON.stringify(credentials, null, 2));
                process.stdout.write(colorette_1.green('  Authorization confirmed. ✅\n\n'));

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "logout",
    value: function logout() {
      var credentialsPath = path_1.resolve(os_1.homedir(), TOKEN_FILENAME);

      if (fs_1.existsSync(credentialsPath)) {
        fs_1.unlinkSync(credentialsPath);
      }

      process.stdout.write('Logged out from the Redocly account. ✋\n');
    }
  }]);

  return RedoclyClient;
}();

exports.RedoclyClient = RedoclyClient;

function isRedoclyRegistryURL(link) {
  var domain = process.env.REDOCLY_DOMAIN || 'redoc.ly';
  if (!link.startsWith("https://api.".concat(domain, "/registry/"))) return false;
  var registryPath = link.replace("https://api.".concat(domain, "/registry/"), '');
  var pathParts = registryPath.split('/'); // we can be sure, that there is job UUID present
  // (org, definition, version, bundle, branch, job, "openapi.yaml" 🤦‍♂️)
  // so skip this link.
  // FIXME

  if (pathParts.length === 7) return false;
  return true;
}

exports.isRedoclyRegistryURL = isRedoclyRegistryURL;